import { createAdminCreateRedirectComponent } from "@/app/router/route-helpers"
import { CreateKind, CreatePrefillKey } from "@/features/create-overlay"

/**
 * The old finance create routes, each replaced by its list page with the create overlay open. Bookmarks and old
 * links keep working; what the old pages read from their query carries over.
 */

/** `/finance/transactions/create?kind=income|expense` (income when absent, as before). */
export const TransactionCreateRedirect = createAdminCreateRedirectComponent((search) =>
  search.get("kind")?.toLowerCase() === "expense" ? CreateKind.Expense : CreateKind.Offering,
)

/** `/finance/transfers/create`. */
export const TransferCreateRedirect = createAdminCreateRedirectComponent(() => CreateKind.Transfer)

/** `/finance/transfers/requests/create?saved=<id>`: the saved calculation still seeds the form. */
export const TransferRequestCreateRedirect = createAdminCreateRedirectComponent(
  () => CreateKind.TransferRequest,
  (search) => {
    const saved = search.get("saved")
    return saved ? { [CreatePrefillKey.SavedTransferCalculation]: saved } : null
  },
)

/** `/finance/pledges/create?activityId=<id>`: the activity is still preselected. */
export const PledgeCreateRedirect = createAdminCreateRedirectComponent(
  () => CreateKind.Pledge,
  (search) => {
    const activityId = search.get("activityId")
    return activityId ? { [CreatePrefillKey.ActivityId]: activityId } : null
  },
)

/** `/budgets/create`. */
export const BudgetCreateRedirect = createAdminCreateRedirectComponent(() => CreateKind.Budget)
